package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.abc_statistic

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme

import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics.ABCStatisticGroupByEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.checkout.CheckoutTabContent
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table.component.DateFilterComponent
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.abc_statistic.component.ABCStatisticTable
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi.StatisticEvent
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi.StatisticState
import org.jetbrains.compose.web.css.px

@Composable
fun ABCStatistic(
    windowSizeMode: WindowSizeModeEnum,
    state: StatisticState,
    event:(StatisticEvent)->Unit,
)
{
    Row(
        modifier = Modifier
            .showContentInOnePage()
    ){

        ABCStatisticSettings(
            windowSizeMode=windowSizeMode,
            state=state,
            event= event,
        )

        ABCStatisticTable(
            items = state.abcStatisticData
        )

    }




}

@Composable
private fun ABCStatisticSettings(
    state: StatisticState,
    event: (StatisticEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .width(Dimen.restaurantProjectWidth)
            .thenIf(
                windowSizeMode != WindowSizeModeEnum.PHONE,
                Modifier.margin(right = Dimen.largePadding)
            )
    )
    {
        MediumContentTitle(
            title = Strings.current().setting,
        )

        DateFilterComponent(
            modifier = Modifier
                .width(Dimen.semiLargeEditTextWidth)
                .margin(
                    top = Dimen.extraLargePadding,
                    bottom = Dimen.highLargePadding,
                ),
            windowSizeMode = windowSizeMode,
            dateStart = state.selectedFromDate ?: "",
            dateEnd = state.selectedToDate ?: "",
            onDateStartFilterClick = {
                event(StatisticEvent.SetFromCalendarFilterDialogStatus(
                    status =! state.showFromCalendarFilterDialog)
                )
            },
            onDateEndFilterClick = {
                event(StatisticEvent.SetToCalendarFilterDialogStatus(
                    status = !state.showToCalendarFilterDialog
                ))
            },
        )


        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = ABCStatisticGroupByEnum.entries,
            label = Strings.current().groupedBy,
            selectedItem = state.selectedGroupBy,
            displayText = {
                if (it is ABCStatisticGroupByEnum)
                    it.title else ""
            },
            onOptionClick = {
                if (it is ABCStatisticGroupByEnum){
                    event(StatisticEvent.UpdateGroupBy(it))
                }

            },
        )

        MediumContentTitle(
            title = Strings.current().selectCashRegisters,
            modifier = Modifier
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(FontWeight.SemiBold)
                .color(Theme.TextSecondary.rgb)
                .fontFamily(FontFamily.Jakarta)
        )

        CheckoutTabContent(
            modifier = Modifier
                .fillMaxHeight()
                .margin(
                    right = if (windowSizeMode== WindowSizeModeEnum.TABLET)
                        Dimen.mediumPadding else 0.px,
                    top = Dimen.highLargePadding,
                ),
            fillMaxWidth = true,
            fillMaxWidthForSearchField = true,
            padding = 0.px,
            showCheckBoxes = false,
            windowSizeMode = windowSizeMode,
            cashList = state.cashList,
            width =Dimen.restaurantProjectWidth,
            borderLess = true,
            cashRegisterIds = state.cashRegisters?.map { it.id?:"" },
            isExpandAll = state.isDevicesExpandAll,
            searchValue = "",
            onSearchValueChange = {

            },
            updateCheckout = {

            },

        )


//        CashRegistersFilter(
//            modifier = Modifier,
//            cashRegisters= state.cashRegisters,
//            title = Strings.current().cashRegisters,
//            showCheckoutDialog = {
//                event(StatisticEvent.SetCheckoutDialogStatus(it))
//            }
//        )

        CustomButton(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = Dimen.extraLargePadding),
            loading = state.abcStatisticCalculationLoading,
            title = Strings.current().calculate,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                event(StatisticEvent.InitABCStatistic)
            }
        )
    }



}


//@Composable
//private fun SettingContent(
//    windowSizeMode: WindowSizeModeEnum,
//    state: StatisticState,
//    event: (StatisticEvent) -> Unit
//) {
//
//
//
////    FilterABCStatistic(
////        windowSizeMode = windowSizeMode,
////        event = event,
////        cashRegisters = state.cashRegisters,
////        selectedPeriodType = state.selectedPeriodType,
////        showDaysFilterDialog = state.showDaysFilterDialog,
////        showFromCalendarFilterDialog = state.showFromCalendarFilterDialog,
////        showToCalendarFilterDialog = state.showToCalendarFilterDialog,
////        selectedDateFrom = parseDateStringToMonthModel(state.selectedFromDate) ,
////        selectedDateTo = parseDateStringToMonthModel(state.selectedToDate) ,
////        selectedFrom = state.selectedFromDate ?: "",
////        selectedTo = state.selectedToDate ?: "",
////        selectedCalendarHeaderYear = state.selectedCalendarHeaderYear,
////    )
//}






